import React, { Component } from 'react';
import { connect } from 'react-redux';
import { deepDiver } from 'helpers/utilities';
import { Field } from 'redux-form';

import { TextField, SelectField } from 'redux-form-material-ui';
import { BooleanRadioButtons } from 'helpers/BooleanRadioButtons';
import MenuItem from 'material-ui/MenuItem';
import { CSSTransitionGroup } from 'react-transition-group';
import FieldItems from 'components/shared/FieldItems/FieldItems';

import * as validator from 'helpers/Validator';
import * as formatter from 'helpers/Formatter';

import { SavedRooms } from '../SavedRooms';
import RoomCard from '../RoomCard/RoomCard';

class AddUnitForm extends Component {
  render() {
    const { name, index } = this.props;
    const { showAddAdditional, floorPlans } = this.props.formProps;
    const property_or_unit_wording = showAddAdditional ? 'Unit' : 'Property';

    const style = {
      add_unit_field: {
        marginTop: '-15px',
        fontSize: '14px',
        width: '100%',
        textAlign: 'left',
      },
      add_unit_boolean_header: {
        textAlign: 'center',
        marginBottom: '5px',
        marginTop: '25px',
      },
      add_unit_boolean: {
        width: '300px',
        margin: 'auto',
        textAlign: 'center',
      },
    };

    const unitTypes = this.props.unitTypes;

    return (
      <div>
        <CSSTransitionGroup
          transitionName="add_unit"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}
        >
          <div key={`unit_form_${index}`}>
            <div className="row" style={{ marginBottom: '25px' }}>
              <div className="row">
                {showAddAdditional && (
                  <div className="col-sm-6" style={{ textAlign: 'center' }}>
                    <Field
                      name={`${name}.unit_number`}
                      type="text"
                      component={TextField}
                      floatingLabelText={`${property_or_unit_wording} Number`}
                      style={style.add_unit_field}
                    />
                  </div>
                )}

                <div
                  className={`col-sm-6 ${!showAddAdditional && ' col-sm-offset-3'}`}
                  style={{ textAlign: 'center' }}
                >
                  <Field
                    name={`${name}.sq_footage`}
                    type="text"
                    component={TextField}
                    floatingLabelText={`${property_or_unit_wording} Size (in sq. ft.)`}
                    style={style.add_unit_field}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <Field
                    name={`${name}.market_rent`}
                    type="text"
                    component={TextField}
                    validate={[validator.greaterThanZero]}
                    floatingLabelText="Monthly Market Rent"
                    style={style.add_unit_field}
                    {...formatter.currencyMask}
                  />
                </div>

                <div className="col-sm-6">
                  <Field
                    name={`${name}.absolute_rent`}
                    type="text"
                    component={TextField}
                    validate={[validator.greaterThanZero]}
                    floatingLabelText="Monthly Absolute Rent"
                    style={style.add_unit_field}
                    {...formatter.currencyMask}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <Field
                    name={`${name}.unit_type_id`}
                    component={SelectField}
                    floatingLabelText="Unit Type"
                    style={style.add_unit_field}
                  >
                    {unitTypes.map(unit => {
                      return (
                        <MenuItem
                          key={`unit_type_${unit.value}`}
                          value={unit.value}
                          primaryText={unit.label}
                        />
                      );
                    })}
                  </Field>
                </div>
                <div className="col-sm-6">
                  <Field
                    name={`${name}.number_of_baths`}
                    component={SelectField}
                    floatingLabelText="Number of Bathrooms"
                    style={style.add_unit_field}
                  >
                    <MenuItem value="1" primaryText="One" />
                    <MenuItem value="2" primaryText="Two" />
                    <MenuItem value="3" primaryText="Three" />
                    <MenuItem value="4" primaryText="Four" />
                    <MenuItem value="5" primaryText="Five" />
                    <MenuItem value="6" primaryText="Six" />
                    <MenuItem value="7" primaryText="Seven" />
                  </Field>
                </div>
              </div>

              {(floorPlans || []).length > 0 && (
                <div className="row">
                  <div className="col-xs-12">
                    <Field
                      name={`${name}.floor_plan`}
                      component={SelectField}
                      floatingLabelText="Floor Plans"
                      style={style.add_unit_field}
                    >
                      {floorPlans.map(floorPlan => (
                        <MenuItem
                          value={floorPlan.id || floorPlan.name}
                          primaryText={floorPlan.name}
                        />
                      ))}
                    </Field>
                  </div>
                </div>
              )}

              <h5 style={style.add_unit_boolean_header}>Accessible?</h5>
              <BooleanRadioButtons name={`${name}.is_accessible`} style={style.add_unit_boolean} />

              <h5 style={style.add_unit_boolean_header}>Is available to rent?</h5>
              <BooleanRadioButtons name={`${name}.is_rentable`} style={style.add_unit_boolean} />

              <h5 style={style.add_unit_boolean_header}>Furnishings</h5>
              <BooleanRadioButtons
                name={`${name}.furnished`}
                style={style.add_unit_boolean}
                trueLabel="Furnished"
                falseLabel="Unfurnished"
              />
              <h5 style={style.add_unit_boolean_header}>Smoking?</h5>
              <BooleanRadioButtons name={`${name}.smoking`} style={style.add_unit_boolean} />
            </div>
          </div>

          <div className="row" style={{ marginTop: '20px' }}>
            <h3 style={{ textAlign: 'center' }}>Rooms within Unit</h3>
            <FieldItems
              name={`units[${index}].rooms`}
              formName={this.props.form}
              renderSavedItems={SavedRooms}
              renderForm={RoomCard}
              dialogHeader="Add Room"
              buttonVerbiageOverride="Add Room"
              formProps={{ skipNodes: 1 }}
            />
          </div>
        </CSSTransitionGroup>
      </div>
    );
  }
}

export default connect(state => ({
  unitTypes: deepDiver(state, 'companyDetails.companyPreferences.unit_types') || [],
}))(AddUnitForm);
